<template>
  <div class="scheme">
    <div class="schemeTop">
      <div
        v-for="(item, i) in productList"
        :key="i"
        @click="toDetail(item, i)"
        :class="['schemeEvery', { active: productCode == item.code }]"
      >
        {{ item.name }}
      </div>
    </div>
    <div>
      <industryVue v-if="productCode == 1" />
      <enterprise v-if="productCode == 2" />
      <personage v-if="productCode == 3" />
    </div>
  </div>
</template>

<script>
import enterprise from "./enterprise.vue";
import industryVue from "./industry.vue";
import personage from "./personage.vue";
export default {
  components: { industryVue, enterprise, personage },
  data() {
    return {
      productCode: 1,
      productList: [
        {
          name: "行业解决方案",
          code: 1,
        },
        {
          name: "企业解决方案",
          code: 2,
        },
        {
          name: "个人解决方案",
          code: 3,
        },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    toDetail(item) {
      this.productCode = item.code;
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.scheme {
  background: #ffffff;
}
.schemeTop {
  display: flex;
  justify-content: center;
  margin-top: 105px;
  position: relative;
  z-index: 99;
  .schemeEvery {
    font-weight: 500;
    font-size: 18px;
    color: #606060;
    line-height: 26px;
    margin-right: 148px;
    position: relative;
    cursor: pointer;
  }
}

.active {
  font-weight: 500 !important;
  font-size: 24px !important;
  color: #141414 !important;
}
.active::after {
  content: "";
  position: absolute;
  bottom: -8px;
  left: 25%;
  width: 50%;
  height: 3px;
  border-radius: 50px;
  background-color: #1c87ff;
}
</style>
